export const EMAIL_TEMPLATES = {
  ACCOUNT_REQUIRES_APPROVAL: 'account_requires_approval',
  ORDER_REQUIRES_ATTENTION: 'order_requires_attention',
  NOTE_TO_ORDER: 'note_to_order',
  CHARGEBACK_DETECTED: 'chargeback_detected',
  ORDER_CHARGEBACK_ALERT: 'order_chargeback_alert',
  IDENTITY_VERIFIED: 'identity_verified',
  MESSAGE_FROM_PATIENT: 'message_from_patient',
  PATIENT_VERIFICATION_DISCREPANCY: 'patient_verification_discrepancy',
  PATIENT_UPLOADED_DOCUMENTS: 'patient_uploaded_documents',
  PAYMENT_REMITTANCE: 'payment_remittance',
  SOFTWARE_FEE_INVOICE: 'software_fee_invoice',
  PATIENT_PAID_SCRIPT_FEE: 'patient_paid_script_fee',
  CONSULT_REQUIRES_REVIEW: 'consult_requires_review',
  CHECKUP_COMPLETED: 'patient_checkup_completed',
  MEDIRECORDS_SYNC_FAILED: 'medirecords_sync_failed',
  NO_PHARMACY_FOUND: 'no_pharmacy_found',
  EXCLUSIVES: 'exclusive_catalogue_items_added',
  PRICE_DIFFERENCE_PAID: 'price_difference_paid',
  FINISH_CONSULT_REMINDER: 'finish_consult_reminder',
  ORDER_SHIPPED_WITH_TRACKING: 'order_shipped_with_tracking',
  PIS_STEP_CREATED: 'pis_step_created',
  PIS_UPDATE_BY_PATIENT: 'pis_update_by_patient',
  PIS_UPDATE_BY_STAFF: 'pis_update_by_staff',
  DUPLICATE_ACCOUNT_FLAGGED: 'duplicate_account_flagged',
  PATIENT_DUPLICATE_CONFLICT: 'patient_duplicate_conflict',
  IDENTITY_DOCUMENTS_UPLOADED: 'identity_documents_uploaded',
  CATALOGUE_ITEMS_ADDED: 'catalogue_items_added',
  MANUAL_AUTH_EMAIL_VERIFICATION: 'manual_auth_email_verification',
  MANUAL_AUTH_EMAIL_PASSWORD_RESET: 'manual_auth_email_password_reset',
} as const;

export type EmailTemplateKey = (typeof EMAIL_TEMPLATES)[keyof typeof EMAIL_TEMPLATES];
